import { CSSProperties, styled } from "@linaria/react";
import { motion } from "framer-motion";
import { SIZE_S } from "../../../constants";
const CardItem = /*#__PURE__*/styled(motion.div)({
  name: "CardItem",
  class: "cyxf49j"
});
const cardDetails = [{
  color: "#FF00E5",
  rotation: -28.9
}, {
  color: "#F27288",
  rotation: 16.9
}, {
  color: "#EC6E58",
  rotation: 30.6
}];

function Card({
  index
}: {
  index: number;
}): JSX.Element {
  const variants = {
    visible: (rotate: number) => {
      return {
        rotate,
        transition: {
          duration: 1.5
        }
      };
    },
    initial: {
      rotate: -45
    }
  };
  const {
    color = "teal",
    rotation = 0
  } = cardDetails[index % cardDetails.length] || {};
  const style: CSSProperties = {
    "--card-color": color
  };
  return <CardItem variants={variants} initial="initial" animate="visible" style={style} custom={rotation} />;
}

export default Card;

require("../../../../.linaria-cache/src/components/homepage/cards/card.linaria.module.css");